
import request from '@/utils/request'
import { ENABLE_API_DBG } from '@/appConfig.js';

function list (params) {
  const {max, offset, ...rest} = params;
  const newParams = {take: max, skip: offset, ...rest};
  const qsParams = new URLSearchParams();
  for (let [key, value] of Object.entries(newParams)) {
    if (!Array.isArray(value)) {
      qsParams.append(key, value);
    }
    else {
      value.forEach(elem => qsParams.append(key, elem));
    }
  }
  //console.log(`api.dept.list: qsParams = ${qsParams.toString()}`);
  return request({
    url: `/dept?${qsParams.toString()}`,
    method: 'get',
    data: params
  })
}
function get (itemId) {
  return request({
    url: `/dept/${itemId}`,
    method: 'get'
  })
}
function getWithTags (itemId) {
  return request({
    url: `/dept/${itemId}?relation=tags`,
    method: 'get'
  })
}
function getWithGroups (itemId) {
  return request({
    url: `/dept/${itemId}?relation=groups`,
    method: 'get'
  })
}
function search (params) {
  return request({
    url: `/dept/search`,
    method: 'post',
    data: params
  })
}
function add (params) {
  ENABLE_API_DBG && console.log(`api.dept.add: params = ${JSON.stringify(params)}`)
  return request({
    url: `/dept`,
    method: 'post',
    data: params
  })
}
function update (params) {
  const {id, ...outParams} = params;
  const url = `/dept/${id}`;
  ENABLE_API_DBG && console.log(`api.dept.update: url = ${url}, outParams = ${JSON.stringify(outParams)}`)
  return request({
    url,
    method: 'patch',
    data: outParams,
  })
}
function remove (itemId) {
  return request({
    url: `/dept/${itemId}`,
    method: 'delete'
  })
}
export default {
    list,
    search,
    add,
    update,
    remove,
    get,
    getWithTags,
    getWithGroups
}
